import withView from '../../cmn/docAutomation/withView';

const InvSalesReturnsTransaction = () => {
    return null;
}

export default withView(InvSalesReturnsTransaction, "invTrans", "")